import script from "./index.vue?vue&type=script&setup=true&name=task&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=task&lang=js"

import "./index.vue?vue&type=style&index=0&id=d38e1820&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d38e1820"]])

export default __exports__